/** Fit image into container (cover) */
export function getInitialScale(
  containerW: number,
  containerH: number,
  imgW: number,
  imgH: number,
): number {
  if (!imgW || !imgH) return 1;
  const scaleX = containerW / imgW;
  const scaleY = containerH / imgH;
  return Math.max(scaleX, scaleY);
}

/** Get product dimensions based on mode */
export function getProductDimensions(product: { width: number; height: number }, mode: string) {
  if (mode === 'mockups') {
    return { width: 900, height: 1200 };
  }
  return { width: product.width, height: product.height };
}

/** Promise-based image loader.
 * First tries with crossOrigin='anonymous' (needed for canvas export / tainted-canvas check).
 * If CORS headers are missing (e.g. S3 bucket without CORS rules), falls back to loading
 * without crossOrigin so the image still renders on screen (canvas will be tainted,
 * i.e. toBlob/toDataURL will throw, but display works fine).
 */
export function loadImage(src: string | null | undefined): Promise<HTMLImageElement | null> {
  return new Promise((resolve) => {
    if (!src) return resolve(null);

    const tryLoad = (useCors: boolean) => {
      const img = new Image();
      if (useCors) img.crossOrigin = 'anonymous';
      img.src = src;
      img.onload = () => resolve(img);
      img.onerror = () => {
        if (useCors) {
          // CORS failed — retry without crossOrigin for display-only
          tryLoad(false);
        } else {
          console.error('Failed to load image:', src);
          resolve(null);
        }
      };
    };

    tryLoad(true);
  });
}
